module.exports = __webpack_public_path__ + "static/media/Linux_Open_Source.06caa05f.png";